import { Table } from "react-bootstrap";
import { euroCents, PricingLine } from "../../context/pricing/PricingContext";

/**
 * De offerteregels: per regel artikelnummer, omschrijving, aantal, stukprijs en
 * bedrag — dezelfde regels die naast de prijslijst gelegd kunnen worden.
 *
 * Gebruikt door het prijsoverzicht in de configurator (live calculatie) en door
 * de orderpagina (de snapshot op de order).
 */
export default function RegelsTabel({ regels }: { regels: PricingLine[] }) {
  return (
    <Table size="sm" className="mt-2" style={{ fontSize: "0.88rem" }}>
      <thead>
        <tr style={{ color: "#6c757d" }}>
          <th style={{ width: 80 }}>Art.nr.</th>
          <th>Omschrijving</th>
          <th style={{ width: 80, textAlign: "right" }}>Aantal</th>
          <th style={{ width: 110, textAlign: "right" }}>Stukprijs</th>
          <th style={{ width: 120, textAlign: "right" }}>Bedrag</th>
        </tr>
      </thead>
      <tbody>
        {regels.map((line, i) => (
          <tr key={`${line.code}:${line.artikelnummer ?? i}`}>
            <td style={{ fontFamily: "monospace" }}>{line.artikelnummer ?? "—"}</td>
            <td>
              {line.omschrijving}
              {line.bron === "config" && (
                <span style={{ marginLeft: 6, fontSize: "0.72rem", color: "var(--c-text-3)" }}>
                  (geen artikel)
                </span>
              )}
            </td>
            <td style={{ textAlign: "right" }}>{line.aantal}</td>
            <td style={{ textAlign: "right" }}>{euroCents(line.stukprijsCents)}</td>
            <td style={{ textAlign: "right" }}>{euroCents(line.regeltotaalCents)}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

/**
 * De artikelregels van een opgeslagen order. Alleen orders vanaf rekenversie 2
 * hebben die; een oudere order (sectiemodel, of van vóór de snapshot) geeft een
 * lege lijst en wordt getoond zoals altijd.
 */
export function regelsUitSnapshot(order: {
  pricingVersion?: number | null;
  pricingLinesJson?: string | null;
}): PricingLine[] {
  if (!order.pricingLinesJson || (order.pricingVersion ?? 0) < 2) return [];
  try {
    const regels = JSON.parse(order.pricingLinesJson);
    return Array.isArray(regels) ? (regels as PricingLine[]) : [];
  } catch {
    return [];
  }
}
